// Startseite: hero wordmark, dann drei klar getrennte Ebenen — das Upload-Angebot
// zuerst (wichtigste Gast-Aktion), gefüllte Galerien als große Cover-Karten und
// leere Kategorien nur als kompakte „Bald verfügbar“-Zeilen. So bleibt die Seite
// kurz, solange noch nichts da ist, und sortiert sich selbst, sobald Inhalte kommen.
import React, { useEffect, useState } from 'react';
import { api, thumbUrl } from '../api.js';
import { Link } from '../router.jsx';
import { GALLERY, HOME } from '../text.js';
import { CameraIcon, ChevronIcon, FilmIcon, HeartIcon, PlusIcon } from '../components/icons.jsx';
import { toast } from '../components/toast.jsx';

// Category preview: up to four thumbnails in a 2x2 grid. Fewer than four still fills
// the frame — the tiles span the leftover cells instead of leaving holes.
function CoverMosaic({ covers }) {
	return (
		<div className={`mosaic mosaic--n${covers.length}`} aria-hidden='true'>
			{covers.map((id) => (
				<img className='mosaic__img' src={thumbUrl({ id })} alt='' loading='lazy' decoding='async' key={id} />
			))}
		</div>
	);
}

export default function Home() {
	const [categories, setCategories] = useState(null);

	useEffect(() => {
		api.categories()
			.then(setCategories)
			.catch(() => toast('Die Galerien konnten nicht geladen werden.', 'error'));
	}, []);

	const uploadCats = categories?.filter((c) => c.allowGuestUpload) ?? [];
	const filledCats = categories?.filter((c) => !c.allowGuestUpload && c.count > 0) ?? [];
	const soonCats = categories?.filter((c) => !c.allowGuestUpload && c.count === 0) ?? [];

	return (
		<div className='home'>
			<section className='home__hero'>
				<h1 className='home__title'>Herzensmomente</h1>
				<div className='home__sub'>Janine &amp; Michi · 11. Juli 2026</div>
				<p className='home__lede'>Alle Fotos und Videos von unserer Hochzeit an einem Ort.</p>
			</section>

			{categories === null && <div className='home__loading'>Wird geladen …</div>}
			{categories?.length === 0 && <div className='home__loading'>{HOME.empty}</div>}

			{uploadCats.map((cat) => (
				<Link to={`/galerie/${cat.id}`} className='upcard' key={cat.id}>
					{cat.covers?.length ? (
						<div className='upcard__preview'>
							<CoverMosaic covers={cat.covers} />
						</div>
					) : (
						<div className='upcard__icons' aria-hidden='true'>
							<CameraIcon size={26} />
							<FilmIcon size={24} />
							<PlusIcon size={18} />
						</div>
					)}
					<div className='upcard__name'>{cat.name}</div>
					<p className='upcard__desc'>{cat.description}</p>
					{cat.count > 0 && <div className='upcard__count'>{HOME.uploadCount(cat.count)}</div>}
					<span className='btn btn--primary'>{HOME.uploadButton}</span>
				</Link>
			))}

			{filledCats.length > 0 && (
				<section className='home__grid' aria-label='Galerien'>
					{filledCats.map((cat, i) => (
						<Link to={`/galerie/${cat.id}`} className='catcard' key={cat.id} style={{ animationDelay: `${i * 70}ms` }}>
							<div className='catcard__media'>
								{cat.covers?.length ? (
									<CoverMosaic covers={cat.covers} />
								) : (
									<div className='catcard__placeholder' aria-hidden='true'>
										<HeartIcon size={38} />
									</div>
								)}
								<div className='catcard__scrim' aria-hidden='true' />
								<div className='catcard__name'>{cat.name}</div>
							</div>
							<div className='catcard__meta'>
								<span className='catcard__count'>{GALLERY.items(cat.count)}</span>
								{cat.hidden && <span className='hiddenbadge'>{HOME.hidden}</span>}
							</div>
							<p className='catcard__desc'>{cat.description}</p>
						</Link>
					))}
				</section>
			)}

			{soonCats.length > 0 && (
				<section className='home__soon' aria-label={HOME.soonTitle}>
					<h2 className='home__soon-title'>{HOME.soonTitle}</h2>
					{soonCats.map((cat) => (
						<Link to={`/galerie/${cat.id}`} className='soonrow' key={cat.id}>
							<span className='soonrow__text'>
								<span className='soonrow__name'>
									{cat.name}
									{cat.hidden && <span className='hiddenbadge'>{HOME.hidden}</span>}
								</span>
								<span className='soonrow__desc'>{cat.description}</span>
							</span>
							<span className='soonrow__chev' aria-hidden='true'>
								<ChevronIcon size={16} />
							</span>
						</Link>
					))}
				</section>
			)}
		</div>
	);
}
